// extracted by mini-css-extract-plugin
export var askAiIcon = "_rr-9";
export var container = "_rr-0";
export var groupSeparator = "_rr-a";
export var highlight = "_rr-4";
export var resultIcon = "_rr-5";
export var resultItem = "_rr-7";
export var resultSubtitle = "_rr-3";
export var resultTitle = "_rr-2";
export var resultsList = "_rr-1";
export var searchGroup = "_rr-6";
export var selected = "_rr-8";